import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", { fill: "#252729" }, [
        _createElementVNode("g", null, [
          _createElementVNode("g", null, [
            _createElementVNode("g", null, [
              _createElementVNode("path", {
                d: "M15 6.667c.46 0 .833.373.833.833v8.333c0 .46-.373.834-.833.834H8.333c-.46 0-.833-.373-.833-.834V7.5c0-.46.373-.833.833-.833H15zm-.417 1.25H8.75v7.5h5.833v-7.5zm-2.916-4.584c.46 0 .833.373.833.834v1.666h-1.25v-1.25H5.417v7.5h1.25v1.25H5c-.46 0-.833-.373-.833-.833V4.167c0-.46.373-.834.833-.834h6.667z",
                transform: "translate(-333 -1757) translate(0 1660) translate(327 91) translate(6 6)"
              })
            ])
          ])
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }